import { render, staticRenderFns } from "./carrier-list.vue?vue&type=template&id=56340d01"
import script from "./carrier-list.vue?vue&type=script&lang=js"
export * from "./carrier-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports